export default __webpack_public_path__ + "static/edge-277269e9682760673871ee1fade92622.png";